!function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.emojiFeedback = n() : e.emojiFeedback = n();
}(this, function () {
  return function (e) {
    var n = {};

    function t(o) {
      if (n[o]) return n[o].exports;
      var a = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
    }

    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: o
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, n) {
      if (1 & n && (e = t(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (t.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var a in e) {
        t.d(o, a, function (n) {
          return e[n];
        }.bind(null, a));
      }
      return o;
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "", t(t.s = 5);
  }([function (e, n, t) {
    var o = t(1);
    "string" == typeof o && (o = [[e.i, o, ""]]);
    var a = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    t(3)(o, a);
    o.locals && (e.exports = o.locals);
  }, function (e, n, t) {
    (e.exports = t(2)(!1)).push([e.i, ".button {\n  text-align: center;\n  background-color: white;\n  border: 1px solid #c8d6e5;\n  -webkit-transition-duration: 0.1s;\n  transition-duration: 0.1s;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.button:hover {\n  border: 1px solid #0abde3;\n}\n\n.active {\n  background-color: #0abde3;\n  font-style: bold;\n}\n\nspan.emoji {\n  font-size: 30px;\n}\n\n.hidden {\n  display: none;\n}\n\n.feedback-form {\n  grid-row: row 4;\n  grid-column: col / span 6;\n  -webkit-animation: slide-down .3s ease-out;\n  -moz-animation: slide-down .3s ease-out;\n}\n\n.feedback-submitted-message {\n  display: grid;\n  grid-gap: 2px;\n  width: 60px;\n  grid-template-columns: [col] 60px [col] 60px [col] 60px [col] 60px [col] 60px;\n  grid-template-rows: [row] auto [row] auto [row];\n  text-align: center;\n  -webkit-animation: slide-down .3s ease-out;\n  -moz-animation: slide-down .3s ease-out;\n}\n\n@-webkit-keyframes slide-down {\n  0% { opacity: 0; -webkit-transform: translateY(-5%); }\n100% { opacity: 1; -webkit-transform: translateY(0); }\n}\n@-moz-keyframes slide-down {\n  0% { opacity: 0; -moz-transform: translateY(-5%); }\n100% { opacity: 1; -moz-transform: translateY(0); }\n}\n\n.feedback-button {\n  width: 80px;\n  float: right;\n  color: #576574;\n}\n\n.feedback-button.ready {\n  background-color: #40B4E5;\n  color: white;\n}\n\n.feedback-button:active {\n  background: #2e86de;\n}\n\n.sk-circle {\n  grid-row: row 5;\n  grid-column: col 3 / span 1;\n  margin: 100px auto;\n  width: 40px;\n  height: 40px;\n  position: relative;\n\n}\n.sk-circle .sk-child {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.sk-circle .sk-child:before {\n  content: '';\n  display: block;\n  margin: 0 auto;\n  width: 15%;\n  height: 15%;\n  background-color: #333;\n  border-radius: 100%;\n  -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;\n          animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;\n}\n.sk-circle .sk-circle2 {\n  -webkit-transform: rotate(30deg);\n      -ms-transform: rotate(30deg);\n          transform: rotate(30deg); }\n.sk-circle .sk-circle3 {\n  -webkit-transform: rotate(60deg);\n      -ms-transform: rotate(60deg);\n          transform: rotate(60deg); }\n.sk-circle .sk-circle4 {\n  -webkit-transform: rotate(90deg);\n      -ms-transform: rotate(90deg);\n          transform: rotate(90deg); }\n.sk-circle .sk-circle5 {\n  -webkit-transform: rotate(120deg);\n      -ms-transform: rotate(120deg);\n          transform: rotate(120deg); }\n.sk-circle .sk-circle6 {\n  -webkit-transform: rotate(150deg);\n      -ms-transform: rotate(150deg);\n          transform: rotate(150deg); }\n.sk-circle .sk-circle7 {\n  -webkit-transform: rotate(180deg);\n      -ms-transform: rotate(180deg);\n          transform: rotate(180deg); }\n.sk-circle .sk-circle8 {\n  -webkit-transform: rotate(210deg);\n      -ms-transform: rotate(210deg);\n          transform: rotate(210deg); }\n.sk-circle .sk-circle9 {\n  -webkit-transform: rotate(240deg);\n      -ms-transform: rotate(240deg);\n          transform: rotate(240deg); }\n.sk-circle .sk-circle10 {\n  -webkit-transform: rotate(270deg);\n      -ms-transform: rotate(270deg);\n          transform: rotate(270deg); }\n.sk-circle .sk-circle11 {\n  -webkit-transform: rotate(300deg);\n      -ms-transform: rotate(300deg);\n          transform: rotate(300deg); }\n.sk-circle .sk-circle12 {\n  -webkit-transform: rotate(330deg);\n      -ms-transform: rotate(330deg);\n          transform: rotate(330deg); }\n.sk-circle .sk-circle2:before {\n  -webkit-animation-delay: -1.1s;\n          animation-delay: -1.1s; }\n.sk-circle .sk-circle3:before {\n  -webkit-animation-delay: -1s;\n          animation-delay: -1s; }\n.sk-circle .sk-circle4:before {\n  -webkit-animation-delay: -0.9s;\n          animation-delay: -0.9s; }\n.sk-circle .sk-circle5:before {\n  -webkit-animation-delay: -0.8s;\n          animation-delay: -0.8s; }\n.sk-circle .sk-circle6:before {\n  -webkit-animation-delay: -0.7s;\n          animation-delay: -0.7s; }\n.sk-circle .sk-circle7:before {\n  -webkit-animation-delay: -0.6s;\n          animation-delay: -0.6s; }\n.sk-circle .sk-circle8:before {\n  -webkit-animation-delay: -0.5s;\n          animation-delay: -0.5s; }\n.sk-circle .sk-circle9:before {\n  -webkit-animation-delay: -0.4s;\n          animation-delay: -0.4s; }\n.sk-circle .sk-circle10:before {\n  -webkit-animation-delay: -0.3s;\n          animation-delay: -0.3s; }\n.sk-circle .sk-circle11:before {\n  -webkit-animation-delay: -0.2s;\n          animation-delay: -0.2s; }\n.sk-circle .sk-circle12:before {\n  -webkit-animation-delay: -0.1s;\n          animation-delay: -0.1s; }\n\n@-webkit-keyframes sk-circleBounceDelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  } 40% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n\n@keyframes sk-circleBounceDelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  } 40% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n\n/* tooltip-hover */\nbutton[data-balloon] {\n  overflow: visible; }\n\n[data-balloon] {\n  position: relative;\n  cursor: pointer; }\n  [data-balloon]:after {\n    filter: alpha(opacity=0);\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    -moz-opacity: 0;\n    -khtml-opacity: 0;\n    opacity: 0;\n    pointer-events: none;\n    -webkit-transition: all 0.18s ease-out 0.18s;\n    -moz-transition: all 0.18s ease-out 0.18s;\n    -ms-transition: all 0.18s ease-out 0.18s;\n    -o-transition: all 0.18s ease-out 0.18s;\n    transition: all 0.18s ease-out 0.18s;\n    font-family: sans-serif !important;\n    font-weight: normal !important;\n    font-style: normal !important;\n    text-shadow: none !important;\n    font-size: 12px !important;\n    background: rgba(17, 17, 17, 0.9);\n    border-radius: 4px;\n    color: #fff;\n    content: attr(data-balloon);\n    padding: .5em 1em;\n    position: absolute;\n    white-space: nowrap;\n    z-index: 10; }\n  [data-balloon]:before {\n    background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(0)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\n    background-size: 100% auto;\n    width: 18px;\n    height: 6px;\n    filter: alpha(opacity=0);\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    -moz-opacity: 0;\n    -khtml-opacity: 0;\n    opacity: 0;\n    pointer-events: none;\n    -webkit-transition: all 0.18s ease-out 0.18s;\n    -moz-transition: all 0.18s ease-out 0.18s;\n    -ms-transition: all 0.18s ease-out 0.18s;\n    -o-transition: all 0.18s ease-out 0.18s;\n    transition: all 0.18s ease-out 0.18s;\n    content: '';\n    position: absolute;\n    z-index: 10; }\n  [data-balloon]:hover:before, [data-balloon]:hover:after, [data-balloon][data-balloon-visible]:before, [data-balloon][data-balloon-visible]:after {\n    filter: alpha(opacity=100);\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    -moz-opacity: 1;\n    -khtml-opacity: 1;\n    opacity: 1;\n    pointer-events: auto; }\n  [data-balloon].font-awesome:after {\n    font-family: FontAwesome; }\n  [data-balloon][data-balloon-break]:after {\n    white-space: pre; }\n  [data-balloon][data-balloon-blunt]:before, [data-balloon][data-balloon-blunt]:after {\n    -webkit-transition: none;\n    -moz-transition: none;\n    -ms-transition: none;\n    -o-transition: none;\n    transition: none; }\n  [data-balloon][data-balloon-pos='down']:after {\n    left: 50%;\n    margin-top: 11px;\n    top: 100%;\n    -webkit-transform: translate(-50%, -10px);\n    -moz-transform: translate(-50%, -10px);\n    -ms-transform: translate(-50%, -10px);\n    transform: translate(-50%, -10px); }\n  [data-balloon][data-balloon-length='small']:after {\n    white-space: normal;\n    width: 80px; }\n  [data-balloon][data-balloon-pos='down-left']:after {\n    left: 0;\n    margin-top: 11px;\n    top: 100%;\n    -webkit-transform: translate(0, -10px);\n    -moz-transform: translate(0, -10px);\n    -ms-transform: translate(0, -10px);\n    transform: translate(0, -10px); }\n  [data-balloon][data-balloon-pos='down-left']:before {\n    background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\n    background-size: 100% auto;\n    width: 18px;\n    height: 6px;\n    left: 5px;\n    margin-top: 5px;\n    top: 100%;\n    -webkit-transform: translate(0, -10px);\n    -moz-transform: translate(0, -10px);\n    -ms-transform: translate(0, -10px);\n    transform: translate(0, -10px); }\n  [data-balloon][data-balloon-pos='down-left']:hover:after, [data-balloon][data-balloon-pos='down-left'][data-balloon-visible]:after {\n    -webkit-transform: translate(0, 0);\n    -moz-transform: translate(0, 0);\n    -ms-transform: translate(0, 0);\n    transform: translate(0, 0); }\n  [data-balloon][data-balloon-pos='down-left']:hover:before, [data-balloon][data-balloon-pos='down-left'][data-balloon-visible]:before {\n    -webkit-transform: translate(0, 0);\n    -moz-transform: translate(0, 0);\n    -ms-transform: translate(0, 0);\n    transform: translate(0, 0); }\n  [data-balloon][data-balloon-pos='down-right']:after {\n    right: 0;\n    margin-top: 11px;\n    top: 100%;\n    -webkit-transform: translate(0, -10px);\n    -moz-transform: translate(0, -10px);\n    -ms-transform: translate(0, -10px);\n    transform: translate(0, -10px); }\n  [data-balloon][data-balloon-pos='down-right']:before {\n    background: no-repeat url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17, 17, 17, 0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E\");\n    background-size: 100% auto;\n    width: 18px;\n    height: 6px;\n    right: 5px;\n    margin-top: 5px;\n    top: 100%;\n    -webkit-transform: translate(0, -10px);\n    -moz-transform: translate(0, -10px);\n    -ms-transform: translate(0, -10px);\n    transform: translate(0, -10px); }\n  [data-balloon][data-balloon-pos='down-right']:hover:after, [data-balloon][data-balloon-pos='down-right'][data-balloon-visible]:after {\n    -webkit-transform: translate(0, 0);\n    -moz-transform: translate(0, 0);\n    -ms-transform: translate(0, 0);\n    transform: translate(0, 0); }\n  [data-balloon][data-balloon-pos='down-right']:hover:before, [data-balloon][data-balloon-pos='down-right'][data-balloon-visible]:before {\n    -webkit-transform: translate(0, 0);\n    -moz-transform: translate(0, 0);\n    -ms-transform: translate(0, 0);\n    transform: translate(0, 0); }", ""]);
  }, function (e, n, t) {
    "use strict";

    e.exports = function (e) {
      var n = [];
      return n.toString = function () {
        return this.map(function (n) {
          var t = function (e, n) {
            var t = e[1] || "",
                o = e[3];
            if (!o) return t;

            if (n && "function" == typeof btoa) {
              var a = (i = o, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */"),
                  r = o.sources.map(function (e) {
                return "/*# sourceURL=" + o.sourceRoot + e + " */";
              });
              return [t].concat(r).concat([a]).join("\n");
            }

            var i;
            return [t].join("\n");
          }(n, e);

          return n[2] ? "@media " + n[2] + "{" + t + "}" : t;
        }).join("");
      }, n.i = function (e, t) {
        "string" == typeof e && (e = [[null, e, ""]]);

        for (var o = {}, a = 0; a < this.length; a++) {
          var r = this[a][0];
          null != r && (o[r] = !0);
        }

        for (a = 0; a < e.length; a++) {
          var i = e[a];
          null != i[0] && o[i[0]] || (t && !i[2] ? i[2] = t : t && (i[2] = "(" + i[2] + ") and (" + t + ")"), n.push(i));
        }
      }, n;
    };
  }, function (e, n, t) {
    var o,
        a,
        r = {},
        i = (o = function o() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === a && (a = o.apply(this, arguments)), a;
    }),
        s = function (e) {
      var n = {};
      return function (e, t) {
        if ("function" == typeof e) return e();

        if (void 0 === n[e]) {
          var o = function (e, n) {
            return n ? n.querySelector(e) : document.querySelector(e);
          }.call(this, e, t);

          if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
            o = o.contentDocument.head;
          } catch (e) {
            o = null;
          }
          n[e] = o;
        }

        return n[e];
      };
    }(),
        l = null,
        c = 0,
        d = [],
        f = t(4);

    function u(e, n) {
      for (var t = 0; t < e.length; t++) {
        var o = e[t],
            a = r[o.id];

        if (a) {
          a.refs++;

          for (var i = 0; i < a.parts.length; i++) {
            a.parts[i](o.parts[i]);
          }

          for (; i < o.parts.length; i++) {
            a.parts.push(y(o.parts[i], n));
          }
        } else {
          var s = [];

          for (i = 0; i < o.parts.length; i++) {
            s.push(y(o.parts[i], n));
          }

          r[o.id] = {
            id: o.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function m(e, n) {
      for (var t = [], o = {}, a = 0; a < e.length; a++) {
        var r = e[a],
            i = n.base ? r[0] + n.base : r[0],
            s = {
          css: r[1],
          media: r[2],
          sourceMap: r[3]
        };
        o[i] ? o[i].parts.push(s) : t.push(o[i] = {
          id: i,
          parts: [s]
        });
      }

      return t;
    }

    function p(e, n) {
      var t = s(e.insertInto);
      if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var o = d[d.length - 1];
      if ("top" === e.insertAt) o ? o.nextSibling ? t.insertBefore(n, o.nextSibling) : t.appendChild(n) : t.insertBefore(n, t.firstChild), d.push(n);else if ("bottom" === e.insertAt) t.appendChild(n);else {
        if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var a = s(e.insertAt.before, t);
        t.insertBefore(n, a);
      }
    }

    function b(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var n = d.indexOf(e);
      n >= 0 && d.splice(n, 1);
    }

    function h(e) {
      var n = document.createElement("style");

      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var o = function () {
          0;
          return t.nc;
        }();

        o && (e.attrs.nonce = o);
      }

      return g(n, e.attrs), p(e, n), n;
    }

    function g(e, n) {
      Object.keys(n).forEach(function (t) {
        e.setAttribute(t, n[t]);
      });
    }

    function y(e, n) {
      var t, o, a, r;

      if (n.transform && e.css) {
        if (!(r = "function" == typeof n.transform ? n.transform(e.css) : n.transform.default(e.css))) return function () {};
        e.css = r;
      }

      if (n.singleton) {
        var i = c++;
        t = l || (l = h(n)), o = w.bind(null, t, i, !1), a = w.bind(null, t, i, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (e) {
        var n = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", g(n, e.attrs), p(e, n), n;
      }(n), o = function (e, n, t) {
        var o = t.css,
            a = t.sourceMap,
            r = void 0 === n.convertToAbsoluteUrls && a;
        (n.convertToAbsoluteUrls || r) && (o = f(o));
        a && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */");
        var i = new Blob([o], {
          type: "text/css"
        }),
            s = e.href;
        e.href = URL.createObjectURL(i), s && URL.revokeObjectURL(s);
      }.bind(null, t, n), a = function a() {
        b(t), t.href && URL.revokeObjectURL(t.href);
      }) : (t = h(n), o = function (e, n) {
        var t = n.css,
            o = n.media;
        o && e.setAttribute("media", o);
        if (e.styleSheet) e.styleSheet.cssText = t;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(t));
        }
      }.bind(null, t), a = function a() {
        b(t);
      });

      return o(e), function (n) {
        if (n) {
          if (n.css === e.css && n.media === e.media && n.sourceMap === e.sourceMap) return;
          o(e = n);
        } else a();
      };
    }

    e.exports = function (e, n) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (n = n || {}).attrs = "object" == typeof n.attrs ? n.attrs : {}, n.singleton || "boolean" == typeof n.singleton || (n.singleton = i()), n.insertInto || (n.insertInto = "head"), n.insertAt || (n.insertAt = "bottom");
      var t = m(e, n);
      return u(t, n), function (e) {
        for (var o = [], a = 0; a < t.length; a++) {
          var i = t[a];
          (s = r[i.id]).refs--, o.push(s);
        }

        e && u(m(e, n), n);

        for (a = 0; a < o.length; a++) {
          var s;

          if (0 === (s = o[a]).refs) {
            for (var l = 0; l < s.parts.length; l++) {
              s.parts[l]();
            }

            delete r[s.id];
          }
        }
      };
    };

    var k,
        v = (k = [], function (e, n) {
      return k[e] = n, k.filter(Boolean).join("\n");
    });

    function w(e, n, t, o) {
      var a = t ? "" : o.css;
      if (e.styleSheet) e.styleSheet.cssText = v(n, a);else {
        var r = document.createTextNode(a),
            i = e.childNodes;
        i[n] && e.removeChild(i[n]), i.length ? e.insertBefore(r, i[n]) : e.appendChild(r);
      }
    }
  }, function (e, n) {
    e.exports = function (e) {
      var n = "undefined" != typeof window && window.location;
      if (!n) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;
      var t = n.protocol + "//" + n.host,
          o = t + n.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, n) {
        var a,
            r = n.trim().replace(/^"(.*)"$/, function (e, n) {
          return n;
        }).replace(/^'(.*)'$/, function (e, n) {
          return n;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r) ? e : (a = 0 === r.indexOf("//") ? r : 0 === r.indexOf("/") ? t + r : o + r.replace(/^\.\//, ""), "url(" + JSON.stringify(a) + ")");
      });
    };
  }, function (e, n, t) {
    "use strict";

    t.r(n);

    var o = function o(e, n) {
      document.getElementById(e).classList.add(n);
    },
        a = function a(e, n) {
      document.getElementById(e).classList.remove(n);
    },
        r = function r(e) {
      var n = document.createElement("p");
      return n.innerHTML = e, n.style.gridColumn = "col / span 6", n.style.gridRow = "row", n.style.textAlign = "center", n.style.fontWeight = "bold", n;
    },
        i = function i(e, n) {
      var t = document.createElement("div"),
          o = n.replace(/\s+/g, "-");
      return t.id = "".concat(e, "-").concat(o), t.className = "button", t;
    },
        s = function s(e, n) {
      var t = document.createElement("div");
      t.classList.add("feedback-form"), t.classList.add("hidden"), t.id = "".concat(e, "-feedback-form");
      var o = r(n.feedbackThankYou);
      o.style.gridColumn = "col / span 6";
      var a = r(n.feedbackTextPrompt);
      a.style.color = "#576574", a.style.textAlign = "center", a.style.fontSize = "14px";

      var s = document.createElement("form"),
          l = function (e) {
        var n = document.createElement("textarea");
        return n.id = "".concat(e, "-feedback-textarea"), n.cols = "30", n.rows = "10", n.maxLength = "500", n.style.width = "100%", n.style.border = "1px solid #c8d6e5", n.style.fontSize = "14px;", n.style.height = "80px", n.style.webkitBorderRadius = "5px", n.style.MozBorderRadius = "5px", n.style.borderRadius = "5px", n;
      }(e),
          c = function (e) {
        var n = document.createElement("div"),
            t = document.createElement("span");
        return n.appendChild(t).innerHTML += "0/500", n.id = "".concat(e, "-maxlength-enforcer"), n.style.color = "#576574", n.style.fontSize = "14px", n;
      }(e);

      s.appendChild(l), s.appendChild(c);
      var d = i(e, "feedback-button");
      return d.classList.add("feedback-button"), d.appendChild(r("Submit")), t.appendChild(o), t.appendChild(a), t.appendChild(s), t.appendChild(d), t;
    },
        l = function l(e, n, t) {
      var o = document.getElementById(e);
      if (!o) throw new Error("The specified element with id does not exist");

      var a = function (e) {
        var n = document.createElement("div");
        return n.className = "wrapper", n.id = "".concat(e, "-wrapper"), n.style.display = "grid", n.style.gridGap = "2px", n.style.width = "60px", n.style.gridTemplateColumns = "[col] 60px [col] 60px [col] 60px [col] 60px [col] 60px", n.style.gridTemplateRows = "[row] auto [row] auto [row]", n;
      }(e),
          l = r(t.introText);

      a.appendChild(l), n.forEach(function (t, o) {
        var r = t.emojicon,
            s = t.emotion,
            l = i(e, s);
        l.style.gridRow = "row 2", l.style.gridColumn = "col ".concat(o + 1, " / span 1"), l.dataset.balloon = s, o === n.length - 1 ? l.dataset.balloonPos = "down-right" : l.dataset.balloonPos = "down-left";
        var c,
            d,
            f,
            u = (c = r, d = s, (f = document.createElement("span")).alt = d, f.className = "emoji", f.innerHTML = c, f);
        l.appendChild(u), a.appendChild(l);
      }), a.appendChild(m(e)), a.appendChild(s(e, t)), a.appendChild(c(e)), o.appendChild(a);
    },
        c = function c(e) {
      var n = document.createElement("div");
      n.id = "".concat(e, "-spinner"), n.className = "sk-circle", n.classList.add("hidden");

      for (var t = 0; t < 12; ++t) {
        var o = document.createElement("div");
        o.classList.add("sk-child"), o.classList.add("sk-circle".concat(t)), n.appendChild(o);
      }

      return n;
    },
        d = function d(e) {
      var n = function (e) {
        var n = document.createElement("div");
        n.className = "feedback-submitted-message", n.classList.add("hidden"), n.id = "".concat(e, "-thank-you");
        var t = r("🙌");
        t.style.fontSize = "30px", t.style.gridRow = "row", t.style.gridColumn = "col / span 6";
        var o = r("Your feedback has been recorded.");
        return o.id = "".concat(e, "-thank-you-message"), o.style.gridRow = "row 2", n.appendChild(t), n.appendChild(o), n;
      }(e);

      document.getElementById(e).appendChild(n);
    },
        f = function f(e) {
      var n = function (e) {
        var n = document.createElement("div");
        n.className = "feedback-submitted-message", n.classList.add("hidden"), n.id = "".concat(e, "-error");
        var t = r("🤦");
        t.style.fontSize = "30px", t.style.gridRow = "row", t.style.gridColumn = "col / span 6";
        var o = r("Our servers are having some issues. Please vote again later.");
        return o.id = "".concat(e, "-error-message"), o.style.gridRow = "row 2", n.appendChild(t), n.appendChild(o), n;
      }(e);

      document.getElementById(e).appendChild(n);
    },
        u = function u(e) {
      var n = document.getElementById(e),
          t = document.getElementById("".concat(e, "-wrapper"));
      n.removeChild(t);
    },
        m = function m(e) {
      var n = document.createElement("div");
      return n.id = "".concat(e, "-total-votes"), n.style.gridRow = "row 3", n.style.gridColumn = "col / span 6", n.style.color = "#576574", n.style.textAlign = "right", n;
    },
        p = function p(e, n) {
      document.getElementById("".concat(e, "-total-votes")).innerHTML = "total votes: ".concat(n > 999 ? function (e) {
        var n = Math.floor(e / 1e3),
            t = Math.round((e - 1e3 * n) / 100);
        return "".concat(n, ".").concat(t, "k");
      }(n) : n);
    };

    function b(e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = null != arguments[n] ? arguments[n] : {},
            o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function (n) {
          h(e, n, t[n]);
        });
      }

      return e;
    }

    function h(e, n, t) {
      return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = t, e;
    }

    var g = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json"
      }
    },
        y = [{
      emojicon: "😁",
      emotion: "beaming face with smiling eyes"
    }, {
      emojicon: "😀",
      emotion: "grinning face"
    }, {
      emojicon: "😐",
      emotion: "neutral face"
    }, {
      emojicon: "😕",
      emotion: "confused face"
    }, {
      emojicon: "😞",
      emotion: "disappointed face"
    }];
    t(0), n.default = function () {
      var e = {
        responses: {
          selectedEmojis: [],
          writtenFeedback: ""
        },
        text: {
          introText: "",
          feedbackTextPrompt: "",
          feedbackThankYou: ""
        },
        endpoints: {
          emoji: "",
          feedback: "",
          votes: ""
        },
        emojis: [],
        entryId: ""
      },
          n = function n(_n) {
        var t = function (e) {
          return document.getElementById("".concat(e, "-feedback-textarea"));
        }(_n);

        t.focus(), t.onkeyup = function () {
          var r = this.value.length;
          e.responses.writtenFeedback = t.value, function (e, n) {
            document.getElementById("".concat(e, "-maxlength-enforcer")).innerHTML = "<span>".concat(n, "</span>/500");
          }(_n, r), r > 0 ? o("".concat(_n, "-feedback-button"), "ready") : a("".concat(_n, "-feedback-button"), "ready");
        };
      },
          t = function t(n) {
        document.getElementById("".concat(n, "-feedback-button")).addEventListener("click", function () {
          var t, r, i, s, l;
          e.responses.writtenFeedback.length > 0 && (o("".concat(n, "-feedback-form"), "hidden"), a("".concat(n, "-spinner"), "hidden"), (t = e, r = t.endpoints, i = t.responses, s = t.text, l = new Date().toISOString(), fetch(r.feedback, b({}, g, {
            body: JSON.stringify({
              timestamp: l,
              pageUrl: window.location.href,
              feedback: i.writtenFeedback,
              question: s.feedbackTextPrompt
            })
          }))).then(function (e) {
            o("".concat(n, "-spinner"), "hidden"), u(n), 200 === e.status ? d(n) : 404 === e.status && f(n);
          }).catch(function () {
            u(n), f(n);
          }));
        });
      },
          r = function r(n, t) {
        var o = function (e, n) {
          return n.map(function (n) {
            var t = n.emotion.replace(/\s+/g, "-");
            return document.getElementById("".concat(e, "-").concat(t));
          });
        }(n, t);

        o.forEach(function (n) {
          n.addEventListener("click", function () {
            !function (n) {
              var t = e.responses.selectedEmojis;
              if (t.map(function (e) {
                return e.emojiId;
              }).includes(n.id)) e.responses.selectedEmojis = t.filter(function (e) {
                return e.emojiId !== n.id;
              });else {
                var o = document.getElementById(n.id).childNodes[0].innerHTML;
                t.push({
                  emojiId: n.id,
                  emojicon: o
                });
              }
            }(n), i(o);
          });
        });
      },
          i = function i(t) {
        var r = e.responses.selectedEmojis;
        !function (e) {
          e.forEach(function (e) {
            return function (e) {
              e.classList.contains("active") && e.classList.remove("active");
            }(e);
          });
        }(t), r.forEach(function (e) {
          var n = e.emojiId;
          return t.find(function (e) {
            return e.id === n;
          }).classList.add("active");
        }), r.length > 0 ? (a("".concat(e.entryId, "-feedback-form"), "hidden"), function (e) {
          var n = e.emojis,
              t = e.responses,
              o = e.endpoints,
              a = e.text,
              r = new Date().toISOString(),
              i = n.map(function (e) {
            return e.emojicon;
          }),
              s = n.map(function (e) {
            return e.emotion;
          }),
              l = t.selectedEmojis;
          fetch(o.emoji, b({}, g, {
            body: JSON.stringify({
              timestamp: r,
              scale: {
                id: "".concat(window.location.href),
                type: "MultiselectionScale",
                question: a.introText,
                points: 5,
                itemLabel: i,
                itemValues: s
              },
              selections: l.map(function (e) {
                return e.emojicon;
              }),
              pageUrl: window.location.href
            })
          }));
        }(e), n(e.entryId)) : o("".concat(e.entryId, "-feedback-form"), "hidden");
      };

      return Object.freeze({
        init: function init(n, o) {
          var a,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              s = i.emojis,
              c = void 0 === s ? y : s,
              d = i.introText,
              f = void 0 === d ? "How do you feel about this graph?" : d,
              u = i.feedbackTextPrompt,
              m = void 0 === u ? "Let us know if you have ideas for new features or improvements below!" : u,
              h = i.feedbackThankYou,
              k = void 0 === h ? "Thank you for your feedback." : h;
          if (null == n) throw new Error("entryId must be specified");
          if (null == o) throw new Error("endpoints must be specified");
          !function (n, t, o) {
            var a = t.emoji,
                r = t.feedback,
                i = t.votes,
                s = o.emojis,
                l = o.introText,
                c = o.feedbackTextPrompt,
                d = o.feedbackThankYou;
            e.endpoints.emoji = a, e.endpoints.feedback = r, e.endpoints.votes = i, e.entryId = n, e.text.introText = l, e.text.feedbackTextPrompt = c, e.text.feedbackThankYou = d, e.emojis = s;
          }(n, o, {
            emojis: c,
            introText: f,
            feedbackTextPrompt: m,
            feedbackThankYou: k
          }), l(n, c, {
            introText: f,
            feedbackTextPrompt: m,
            feedbackThankYou: k
          }), r(n, c), t(n), (a = e.endpoints.votes, fetch(a, b({}, g, {
            method: "GET"
          })).then(function (e) {
            return e.json().then(function (e) {
              return e.votes;
            });
          })).then(function (e) {
            return p(n, e);
          }).catch(function (e) {
            return console.log("Failed to fetch votes: ".concat(e));
          });
        },
        getState: function getState() {
          return e;
        },
        destroy: function destroy(e) {
          var n = document.getElementById("".concat(e, "-wrapper"));
          n.parentNode.removeChild(n);
        }
      });
    };
  }]);
});